/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export class LoanQuerySearchCriteria { 
  loanNumber?: string;
  fhaCaseNumber?: string;
  lenderLoanNumber?:string;
  servicerNumber?: string;
  loanStatus?: string;
  paymentStatus?: string;
  paymentPlan?: string;
  productType?: string;
  purchaseDateStart?: string;
  purchaseDateEnd?: string;
  fundingDateStart?: string;
  fundingDateEnd?: string;
  interestRateStart?: string;
  interestRateEnd?: string;
  loanBalanceStart?: string;
  loanBalanceEnd?: string;
  servicerNumberList?: Array<string>;
}
